import { fetchMFAPreference, fetchUserAttributes, signOut } from 'aws-amplify/auth'
import { useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import AuthService from 'services/AuthService'
import { utilityService } from 'services/UtilityService'
import { message } from 'antd'
import { useUserPermissions, useCheckUserAccess } from 'graphQLHooks/general/general'
import { isEmpty } from 'lodash'

const ProtectedRoute = ({ children, history }) => {
  const projectValue = useRef(utilityService.getCurrentProject())
  const [userAttributes, setUserAttributes] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const {
    data: permissionData,
    refetch: refetchPermissions
  } = useUserPermissions({
    variables: {
      id: userAttributes?.email,
      project: projectValue?.current
    },
    skip: !userAttributes?.email,
    onCompleted: (data) => windowSetter(data, projectValue),
    fetchPolicy: 'network-only'
  })

  const {
    refetch: getUserMfaStatus
  } = useCheckUserAccess({
    variables: {
      id: userAttributes?.email,
      project: projectValue?.current
    },
    skip: isEmpty(userAttributes?.email),
    onCompleted: windowSetter,
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    checkAuth()
  }, [])

  const logOut = async () => {
    await signOut()
    history.push('/')
  }

  async function checkAuth () {
    try {
      const attributes = await fetchUserAttributes()
      const userAccessDetails = await getUserMfaStatus({
        user: attributes?.email,
        project: projectValue.current
      })
      const userAccessData = userAccessDetails?.data?.checkUserAccess
      if (!userAccessData.projectAccess) {
        message.error(`You don't have access to this to project`)
        await logOut()
      }
      const mfaPreferences = await fetchMFAPreference()
      const isNoMfa = !mfaPreferences?.preferred
      const name = attributes?.name
      const email = attributes?.email
      const hasNoMfaAndMfaNotConfigured = isNoMfa && !userAccessData.mfaStatus
      const hasNameOrEmail = name || email
      // console.log('isNoMfa', {
      //   isNoMfa,
      //   mfaPreferences,
      //   attributes,
      //   mfaStatus: userAccessData,
      //   name,
      //   email,
      //   project: projectValue.current,
      //   cond: hasNameOrEmail && !hasNoMfaAndMfaNotConfigured
      //   // hasNameOrEmail,
      //   // hasMfaButNotAuthenticated
      // })
      if (!(hasNameOrEmail && !hasNoMfaAndMfaNotConfigured)) {
        await logOut()
      }
      setIsAuthenticated(true)
      setUserAttributes(attributes)
    } catch (error) {
      utilityService.handleError(error)
      setIsAuthenticated(false)
      AuthService.clearUserDetails()
      await logOut()
    }
  }

  const userPermission = permissionData?.getUserPermissions || {}
  return isAuthenticated
    ? children({ userAttributes, userPermission, refetchPermissions })
    : null
}

export default withRouter(ProtectedRoute)

// TODO:: Keep old logic as is, need to explore on what this does and what this is for
const windowSetter = (data, projectValue) => {
  const project = projectValue.current
  const getUserPermissions = data?.getUserPermissions
  if (getUserPermissions) {
    let permissions = getUserPermissions.permissions
    if (project === 'vcms' && permissions.ASSET_MANAGER.length === 0 &&
        permissions.BUCKET_MANAGER.length === 0 &&
        permissions.CHANNEL_MANAGER.length === 0 &&
        permissions.CONTENT_BANK.length === 0 &&
        permissions.DATA_MANAGER.length === 0 &&
        permissions.JOB_MANAGER.length === 0 &&
        permissions.MATCH_MANAGER.length === 0 &&
        permissions.ROLE_MANAGER.length === 0) {
      window.csm_only_user_access = true
    } else if ((project === 'hyperion' || project === 'projectx') && permissions.ASSET_MANAGER.length === 0 &&
        permissions.BUCKET_MANAGER.length === 0 &&
        permissions.CONTENT_BANK.length === 0 &&
        permissions.DATA_MANAGER.length === 0 &&
        permissions.PARTNER_MANAGER.length === 0 &&
        permissions.OFFER_MANAGER.length === 0 &&
        permissions.ROLE_MANAGER.length === 0) {
      window.csm_only_user_access = true
    } else {
      window.csm_only_user_access = false
    }
  }
}
